import { render, staticRenderFns } from "./profilePhotos.vue?vue&type=template&id=28989b24&scoped=true"
import script from "./profilePhotos.vue?vue&type=script&lang=js"
export * from "./profilePhotos.vue?vue&type=script&lang=js"
import style0 from "./profilePhotos.vue?vue&type=style&index=0&id=28989b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28989b24",
  null
  
)

export default component.exports